import React from "react";
import { IHarvestApplicationResponseModel } from "../../../typings/models/HarvestApplicationResponseModel";
import { useNavigate } from "react-router-dom";
import moment from "moment";

interface GridRowProps {
  data: IHarvestApplicationResponseModel;
}

const HarvestApplicationsGridRow: React.FC<GridRowProps> = ({ data }) => {
  let navigate = useNavigate();

  const handleViewClick = (id: string, status: string) => {
    let path = `/harvest-details`;
    navigate(path, { state: { id: id, status: status, mode: "view" } });
  };
  return (
    <tr>
      <td>{data.requestReferenceNumber}</td>
      <td>{data.brooderMicrochipNumber}</td>
      <td>{data.batchNumber}</td>
      <td>{data.uen}</td>
      <td>{data.companyName}</td>
      <td>{data.harvestDateString}</td>
      <td>{data.mobileNo}</td>
      <td>{data.email}</td>
      <td>{data.requestSubmissionDateString}</td>
      <td className="hidden">{data.harvestDetailsStatus}</td>
      <td>
        <a
          href="#"
          onClick={() =>
            handleViewClick(
              data.harvestDetailsApplicationId,
              data.harvestDetailsStatus
            )
          }
        >
          View
        </a>
      </td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default HarvestApplicationsGridRow;
